import axios from "axios";

export const LOGIN_URL = "api/cms/auth/login";
export const REGISTER_URL = "api/cms/auth/register";
export const REQUEST_PASSWORD_URL = "api/cms/auth/forgot-password";

export const GET_USER_URL = "api/cms/auth/getUser";

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(GET_USER_URL);
}
